<template>
	<div v-if="dataLoaded">
		<div v-show="!showFields">
			<v-toolbar color="blue" class="white--text">
				<v-toolbar-title>Porównywane wersje są identyczne</v-toolbar-title>
			</v-toolbar>
		</div>

		<div v-show="showFields">
			<div v-if="genericComparisonData">
				<h2 style="margin-left: 20px">{{genericForm.sections[0].name}} </h2>
				<vue-form-generator
					:disabled="true"
					:name="'persistentGenerator'"
					:model="genericComparisonData.model"
					:schema="genericComparisonData.schema"
				/>
			</div>

			<div v-if="financialDocumentsIncluded" v-show="showFields">
				<final-report-administrative-header/>

				<financial-table-types-top-header/>

				<financial-table-cost-headers/>

				<v-card>
					<final-report-comparison-costs
						:current-costs="administrativeMerged.costs"
						:old-costs="previousAdministrativeMerged.costs"
						@dataDiffer="showDifference"
					/>
				</v-card>

				<financial-report-costs-header/>

				<financial-table-types-top-header/>

				<financial-table-cost-headers/>

				<v-card
					:key="actionComparison.serialNumber"
					v-for="actionComparison in costsMergedComparison"
				>
					<final-report-comparison-action
						v-if="actionComparison.oldAction"
						:old="true"
						:serial-number="actionComparison.serialNumber"
						:costs="actionComparison.oldCosts"
						:other-costs="actionComparison.currentCosts"
						:action-name="actionComparison.oldAction"
						:other-action-name="actionComparison.currentAction"
						@dataDiffer="showDifference"
					/>
					<final-report-comparison-action
						v-if="actionComparison.currentAction"
						:old="false"
						:serial-number="actionComparison.serialNumber"
						:costs="actionComparison.currentCosts"
						:other-costs="actionComparison.oldCosts"
						:action-name="actionComparison.currentAction"
						:other-action-name="actionComparison.oldAction"
						@dataDiffer="showDifference"
					/>
					<final-report-comparison-costs
						:parent-serial-number="actionComparison.serialNumber"
						:current-costs=actionComparison.currentCosts
						:old-costs="actionComparison.oldCosts"
						@dataDiffer="showDifference"
					/>
				</v-card>

				<final-report-header-row
					class="mt-5"
					text="2. Rozliczenie ze względu na źródło finansowania"
				/>
				<final-report-data-row
					text1="Lp."
					text2="Źródło finansowania"
					text3="Koszty zgodnie z umową (w zł)"
					text4="Faktycznie poniesione wydatki (w zł)"

					:colors="[0, 1, 1, 1]"
				/>

				<final-report-comparison-summary-row
					:index="1"
					label="Dotacja, w tym odsetki bankowe od dotacji oraz inne przychody ogółem"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="1.1"
					label="Dotacja"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="1.2"
					label="Odsetki od dotacji"
					:document-only="true"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.INTEREST])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.INTEREST])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="1.3"
					label="Inne przychody"
					:document-only="true"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME])"
				/>

				<final-report-comparison-summary-row
					:index="2"
					label="Inne środki finansowe ogółem"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="2.1"
					label="Środki finansowe własne"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="2.2"
					label="Świadczenia pieniężne od odbiorców"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.MONEY_FROM_RECIPIENTS])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.MONEY_FROM_RECIPIENTS])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.MONEY_FROM_RECIPIENTS])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.MONEY_FROM_RECIPIENTS])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="2.3"
					label="Świadczenia pieniężne z innych źródeł publicznych"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER_PUBLIC_SOURCE])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER_PUBLIC_SOURCE])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER_PUBLIC_SOURCE])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER_PUBLIC_SOURCE])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="2.4"
					label="Pozostałe"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER])"
				/>
				<final-report-comparison-summary-row
					:index="3"
					label="Wkład osobowy i rzeczowy ogółem"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="3.1"
					label="Koszty pokryte z wkładu osobowego"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
				/>
				<final-report-comparison-summary-row
					:sub-row="true"
					:index="3.2"
					label="Koszty pokryte z wkładu rzeczowego"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				/>
				<final-report-comparison-summary-row
					:index="4"
					label="Ogółem"
					:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL])"
					:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL])"
					:other-from-document="otherFormattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL])"
					:other-from-project="otherFormattedSumOfCostsFromTypesFromProject([FundingTypes.ALL])"
				/>
				<final-report-comparison-summary-row
					:is-percentage="true"
					:index="5"
					label="Udział wkładu własnego w stosunku do kwoty dotacji"
					:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-document="otherPercentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
					:other-from-project="otherPercentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				/>
				<final-report-comparison-summary-row
					:is-percentage="true"
					:index="6"
					label="Udział kwoty dotacji w całkowitych kosztach zadania publicznego"
					:from-document="percentDotationFromDocumentFormatted()"
					:from-project="percentDotationFromProjectFormatted()"
					:other-from-document="otherPercentDotationFromDocumentFormatted()"
					:other-from-project="otherPercentDotationFromProjectFormatted()"
				/>
				<final-report-comparison-summary-row
					:is-percentage="true"
					:index="7"
					label="Udział innych środków finansowych w stosunku do kwoty dotacji"
					:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:other-from-document="otherPercentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
					:other-from-project="otherPercentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
				/>

				<final-report-comparison-summary-row
					:is-percentage="true"
					:index="8"
					label="Udział wkładu osobowego i rzeczowego w stosunku do kwoty dotacji"
					:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:other-from-document="otherPercentSumOfCostsToDotationFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
					:other-from-project="otherPercentSumOfCostsToDotationFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
				/>

				<final-report-invoices-comparison class="mt-5 mb-5"
					:old-invoices="previousFinalReport.fromDocuments.invoices"
					:current-invoices="finalReport.fromDocuments.invoices"
					@dataDiffer="showDifference"/>
			</div>
		</div>
	</div>
</template>

<script>
	import {FinalReport} from "@/api/generated/FinalReport";
	import {FinalReportCostsUtils} from "./Utils/FinalReportCostsUtils";
	import FinalReportComparisonCosts from "./FinalReportComparisonCosts";
	import FinalReportComparisonAction from "./finalReportComparisonAction";
	import FinalReportAdministrativeHeader from "./FinalReportAdministrativeHeader";
	import FinancialTableTypesTopHeader from "./FinancialTableTypesTopHeader";
	import FinancialTableCostHeaders from "./FinancialTableCostHeaders";
	import FinancialReportCostsHeader from "./FinancialReportCostsHeader";
	import FinalReportHeaderRow from "./FinalReportHeaderRow";
	import FinalReportDataRow from "./FinalReportDataRow";
	import FinalReportComparisonSummaryRow from "./FinalReportComparisonSummaryRow";
	import {FundingTypes} from "./Utils/FinalReportFundingTypes";
	import FinalReportInvoicesComparison from "./FinalReportInvoicesComparison";
	import {Api} from "@/api";
	import {genericFormUtil} from "@/utils/genericFormUtil";
  import {Project} from "@/api/generated/Project";

	export default {
		name: "FinalReportComparison",
		components: {
			FinalReportInvoicesComparison,
			FinalReportComparisonSummaryRow,
			FinalReportDataRow,
			FinalReportHeaderRow,
			FinancialReportCostsHeader,
			FinancialTableCostHeaders,
			FinancialTableTypesTopHeader,
			FinalReportAdministrativeHeader,
			FinalReportComparisonAction,
			FinalReportComparisonCosts
		},
		mixins: [FinalReportCostsUtils],

		data () {
			return {
				FundingTypes: FundingTypes,

				projectId: this.$route.params.projectId,
				finalReport: null,
				previousFinalReport: null,

				costsMerged: null,
				previousCostsMerged: null,
				costsMergedComparison: null,

				administrativeMerged: null,
				previousAdministrativeMerged: null,

				projectData: null,
				invoicesData: null,
        financialDocumentsIncluded: false,

				genericForm: null,
				genericComparisonData: null,

        showFields: false,

				firstVersion: this.$route.params.firstVersion,
				secondVersion: this.$route.params.secondVersion,
			};
		},

		async beforeMount () {
			await this.loadDataFromServer();
		},

		computed: {
			dataLoaded () {
				return this.finalReport && this.previousFinalReport;
			}
		},

		methods: {
			otherFormattedSumOfCostsFromTypesFromProject (types) {
				return this.formattedSumOfCostsFromTypesFromProject(types, null, true);
			},

			otherFormattedSumOfCostsFromTypesFromDocument (types) {
				return this.formattedSumOfCostsFromTypesFromDocument(types, null, true);
			},

			otherPercentSumOfCostsToDotationFromDocument (types) {
				return this.percentSumOfCostsToDotationFromDocument(types, null, true);
			},

			otherPercentSumOfCostsToDotationFromProject (types) {
				return this.percentSumOfCostsToDotationFromProject(types, null, true);
			},

			otherPercentDotationFromProjectFormatted () {
				return this.percentDotationFromProjectFormatted(null, true);
			},

			otherPercentDotationFromDocumentFormatted () {
				return this.percentDotationFromDocumentFormatted(null, true);
			},

			compute () {
				if (!this.dataLoaded) {
					return;
				}
				this.calculateAllMergedCosts();
				this.calculateActionsCostsMergedComparison();
				this.processGenericComparisonData();
			},

			calculateActionsCostsMergedComparison () {
				this.costsMergedComparison = [];

				let findCostComparison = (serialNumber) =>
					this.costsMergedComparison.find(x => x.serialNumber === serialNumber);

				let addMissingSerialNumbersInComparison = (action) => {
					if (!findCostComparison(action.serialNumber)) {
						this.costsMergedComparison.push({serialNumber: action.serialNumber});
					}
				};

				this.costsMerged.forEach(addMissingSerialNumbersInComparison);
				this.previousCostsMerged.forEach(addMissingSerialNumbersInComparison);

				let fillComparisonDefaultPropertiesValues = (comparison) => {
					comparison.currentAction = "";
					comparison.oldAction = "";
					comparison.currentCosts = [];
					comparison.oldCosts = [];
				};

				this.costsMergedComparison.forEach(fillComparisonDefaultPropertiesValues);

				let assignOldCosts = (action) => findCostComparison(action.serialNumber).oldCosts = action.costs;
				let assignOldName = (action) => findCostComparison(action.serialNumber).oldAction = action.action;

				this.previousCostsMerged.forEach(assignOldCosts);
				this.previousCostsMerged.forEach(assignOldName);

				let assignCurrentCosts = (action) => findCostComparison(action.serialNumber).currentCosts = action.costs;
				let assignCurrentName = (action) => findCostComparison(action.serialNumber).currentAction = action.action;

				this.costsMerged.forEach(assignCurrentCosts);
				this.costsMerged.forEach(assignCurrentName);

				this.costsMergedComparison.sort((a, b) => a.serialNumber - b.serialNumber);

			},

			calculateAllMergedCosts () {
				this.projectData = this.finalReport.fromProject;
				this.invoicesData = this.finalReport.fromDocuments.invoices;
				this.costsMerged = this.calculateCostsMerged();
				this.administrativeMerged = this.calculateAdministrativeMerged();

				this.projectData = this.previousFinalReport.fromProject;
				this.invoicesData = this.previousFinalReport.fromDocuments.invoices;
				this.previousCostsMerged = this.calculateCostsMerged();
				this.previousAdministrativeMerged = this.calculateAdministrativeMerged();
			},

			processGenericComparisonData () {
				if (!this.genericForm || !this.previousFinalReport.filledForm || !this.finalReport.filledForm) {
					this.genericComparisonData = null;
				} else {
					this.genericComparisonData = this.prepareSchemaAndModel(); // final report has only one section
          if (!this.genericComparisonData.dataSame) {
            this.showDifference();
          }
				}
			},

			prepareSchemaAndModel () {
				let oldSchema = this.getPersistentSchemaForComparing(this.previousFinalReport.filledForm, 0);
				let currentSchema = this.getPersistentSchemaForComparing(this.finalReport.filledForm, 0);
				return genericFormUtil.mergeTwoSchemasAndModelToCompare(oldSchema, currentSchema, {fields: this.previousFinalReport.filledForm}, {fields: this.finalReport.filledForm});
			},

			getPersistentSchemaForComparing (model, sectionIndex) {
				let sections = model.sections;

        if (!this.genericForm) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				let schema = genericFormUtil.getSectionSchemaFromSchema(this.genericForm, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
				} else {
					return schema;
				}
			},

      showDifference() {
        this.showFields = true;
      },

			async loadDataFromServer () {
				await Api.syncGet(this, "/final-report/configuration?projectId=".concat(this.projectId), successResponse => {
					this.genericForm = genericFormUtil.decodeSchema(successResponse.schema);
				});
        Project.getPublicBasicData(this, this.$route.params.projectId, projectBasicData => {
          this.financialDocumentsIncluded = projectBasicData.financialDocumentsIncluded;
        });
		FinalReport.getVersionData(this, this.projectId, this.firstVersion ,  (response) => {
					this.previousFinalReport = response;
					this.previousFinalReport.filledForm = genericFormUtil.decodeSchema(this.previousFinalReport.filledForm);
					this.compute();
				});

				FinalReport.getVersionData(this, this.projectId, this.secondVersion, (response) => {
					this.finalReport = response;
					this.finalReport.filledForm = genericFormUtil.decodeSchema(this.finalReport.filledForm);
					this.compute();
				});
			}
		}
	};
</script>

<style scoped>

</style>